// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cPME2","top":"styles_top__1LbIh","left":"styles_left__2ntmV","description":"styles_description__3xBRv"};